<template>
  <!--从模板创建文件夹-->
  <dialog-el
    :value="show"
    :title="$t('创建文件夹结构')"
    @close="dialogShow"
  >
    <div class="confirm-dialog">
      <div class="confirm-body">
        <div
          v-ie-placeholder
          class="file-name-tpl"
        >
          <span class="input-label">{{ $t('文件夹名称') }}：</span>
          <input
            v-model.trim="folderName"
            type="text"
            class="filename-input"
            :class="{'error-name':showNameError}"
            autofocus
            :placeholder="$t('请输入文件夹名')"
            @keyup="toChangeName"
          >
        </div>
        <div
          v-show="showNameError"
          class="form-tips-error"
        >
          {{ $t('文件夹名称不能为空') }}
        </div>
        <div class="select-tpl">
          <span class="input-label">{{ $t('选择模板') }}：</span>
          <div
            v-ie-placeholder
            class="tplselect-box"
          >
            <input
              v-model="selectedTpl.name"
              type="text"
              class="filename-input tpl-select"
              readonly
              :placeholder="$t(&quot;请选择模板&quot;)"
              @click="selectTpl()"
            >
            <ul
              v-if="selectTplShow"
              class="tpl-list"
              @scroll="loadMoreTemp"
              @mouseleave="hideSelectTpl"
            >
              <li class="tpl-list-title">
                <span>{{ $t('模板名称') }}</span>
                <span>{{ $t('文件夹数量') }}</span>
                <span>{{ $t('说明') }}</span>
              </li>
              <li
                v-for="(item,index) in tplList"
                :key="index"
                class="tpl-item"
                @click="getTplItem(index,item.id)"
              >
                <span :title="item.name">{{ item.name }}</span>
                <span>{{ item.ftCount }}</span>
                <span :title="item.remark">{{ item.remark }}</span>
              </li>
              <div
                v-show="tplList.length === 0"
                class="no-content"
              >
                {{ $t('管理员还未设置文件夹模板') }}
              </div>
            </ul>
          </div>
        </div>
        <div class="preview-tpl">
          <span class="input-label">{{ $t('模板预览') }}：</span>
          <div class="template-preview">
            <span
              v-show="treeData.length > 0"
              class="template-title"
            >{{ $t('模板:') }}</span>
            <el-tree
              :empty-text="$t('选择模板后显示预览')"
              :data="treeData"
              :props="{label:'name'}"
              node-key="id"
              highlight-current
            >
              <span
                slot-scope="{ node }"
                :title="$t(node.label)"
                class="template-preview-item"
              >
                <span class="icon-file folder" />
                <span class="directory-label">{{ $t(node.label) }}</span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="confirm-footer">
        <div
          class="confirm-btn lv-btn default-btn"
          @click="dialogShow"
        >
          {{ $t('取消') }}
        </div>
        <div
          class="confirm-btn lv-btn primary-btn"
          :class="{'disabled': !actionCreate}"
          @click="createFolder"
        >
          {{ $t('确定') }}
        </div>
      </div>
    </div>
  </dialog-el>
</template>

<script>

import * as Util from 'js/util/util'
import store from 'store'
import dialogEl from 'components/common/dialog'

const { postData } = require('js/api/getdata').default

export default {
  components: {
    dialogEl,
  },
  data() {
    return {
      show: false,
      selectTplShow: false,
      selectDcShow: false,
      pageNum: 0,
      pageSize: 20,
      total: 0,
      left: 0,
      top: 0,
      folderName: '',
      selectedTpl: {},
      selectedDc: '',
      dcList: [],
      tplList: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      changeName: false,
      showError: false,
    }
  },
  computed: {
    actionCreate() {
      return this.folderName.length > 0 && this.selectedTpl.id
    },
    pathType() {
      const { $route } = this
      return $route.meta.path_type || $route.name
    },
    accountId() {
      return store.getters.accountId
    },
    showNameError() {
      return !this.folderName && this.showError
    },
  },
  watch: {
    show(val) {
      if (Util.isClient()) {
        const WndName = 'MainWndTitle'
        const Operate = val ? 'hide' : 'show'
        Util.controlClientWnd(Operate, WndName)
      }
    },
  },
  created() {
    window.onresize = () => {
    }
  },
  methods: {
    dialogShow() {
      this.show = !this.show
      if (!this.show) {
        this.folderName = ''
        this.selectedTpl = {}
        this.treeData = []
      }
    },
    selectTpl() {
      this.selectTplShow = !this.selectTplShow
      if (this.selectTplShow) {
        this.pageSize = 20
        this.getTplList()
      }
    },
    hideSelectTpl() {
      this.pageSize = 20
      this.selectTplShow = false
    },
    selectDc() {
      this.selectDcShow = !this.selectDcShow
    },
    hideSelectDc() {
      this.selectDcShow = false
    },
    setDcItem(i) {
      this.hideSelectDc()
      this.selectedDc = this.dcList[i]
    },
    getTplList() {
      const data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        needCount: true,
      }
      postData('getTplList', data).then((res) => {
        if (!res) return
        if (res.status === 200) {
          this.tplList = res.data.data
          this.total = res.data.total
        }
      })
    },
    loadMoreTemp(e) {
      if (e.target.clientHeight + Math.round(e.target.scrollTop) >= e.target.scrollHeight
        && this.total > this.tplList.length) {
        this.pageSize += 20
        this.getTplList()
      }
    },
    renderTree(tplid) {
      const data = {
        ftId: tplid,
        nsid: this.$store.state.currentData.nsid,
      }
      postData('getFolderTplDetail', data).then((res) => {
        if (res.status === 200) {
          this.treeData = res.data.data
        }
      })
    },
    toChangeName() {
      this.changeName = true
      this.showError = false
    },
    getTplItem(i, id) {
      this.hideSelectTpl()
      this.treeData = []
      this.selectedTpl = this.tplList[i]
      this.renderTree(id)
      if (this.folderName === '' || !this.changeName) this.folderName = this.tplList[i].name
    },
    createFolder() {
      if (this.actionCreate) {
        const data = {
          // foldertemplate_id: this.selectedTpl.id,
          // path_type: this.pathType,
          // amount: this.selectedTpl.amount,
          // dc_id: this.selectedDc,
          neid: this.$store.state.currentData.neid,
          folderName: this.folderName,
          ftId: this.selectedTpl.id,
          nsid: this.$store.state.currentData.nsid,
        }
        const param = {}
        let urlTail
        if (localStorage.getItem('currentPath') === '/') {
          urlTail = `/${this.folderName}`
        } else {
          urlTail = `${localStorage.getItem('currentPath')}/${this.folderName}`
        }
        param.url = urlTail
        if (!this.folderName) {
          this.showError = true
          return
        }
        postData('tplToFolder', data).then((res) => {
          if (res.status === 200) {
            this.dialogShow()
            this.$emit('showTips')
            this.$emit('refreshList', { refresh: true, url: urlTail })
          }
        }).catch((error) => {
          const err = error.response.data
          this.$emit('showTips', err.message, 'error')
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.confirm-dialog {
  .confirm-body {
    padding: 0 24px;
    min-width: 360px;
    line-height: 20px;
    .file-name-tpl, .select-dc, .select-tpl, .preview-tpl {
      width: 100%;
      height: auto;
      display: block;
      margin-top: 20px;
      // margin-right: 3px;
      span {
        float: left;
        width: 85px;
        line-height: 36px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .input-label {
        width: 95px;
      }
      .error-name{
        border-color: red;
      }
      .template-title{
        float: none;
        margin-left: 14px;
        display: block;
        margin-top: 8px;
        color: #aaa;
        font-size: 15px;
      }
      .template-preview-item{
        width: auto;
      }
      .icon-file{
        background-image: url(~image/list-mode.png);
        background-repeat: no-repeat;
        float: left;
        height: 24px;
        margin: 6px 10px 0 0;
        width: 24px;
        &.folder{
          background-position: -252px -41px;
        }
      }
      .directory-label{
        float: none;
      }
      input {
        display: block;
        position: relative;
        height: 36px;
        width: 545px;
        line-height: 32px;
        border: 1px solid #C6CDD7;
        border-radius: 2px;
        outline: none;
        // margin-left: 9px;
        overflow: hidden;
        padding-left: 12px;
        box-sizing: border-box;
      }
      .tpl-select, .tpl-item, .dc-select, .dc-item {
        cursor: pointer;
      }
      .tplselect-box {
        position: relative;
      }
      .tpl-list, .dc-list {
        position: absolute;
        top: 36px;
        left: 95px;
        overflow-x: hidden;
        height: 192px;
        width: 543px;
        border: 1px solid #C6CDD7;
        border-radius: 2px;
        overflow-y: scroll;
        box-sizing: border-box;
        background-color: white;
        z-index: 999;
        .tpl-list-title {
          border-bottom: 1px solid #e8ebef;
          span {
            color: #aaa;
          }
        }
        .tpl-list-title, .tpl-item, .dc-item {
          width: 100%;
          height: 35px;
          display: block;
          padding: 8px;
          span {
            width: 166px;
          }
        }
        .tpl-item:hover, .dc-item:hover {
          background-color: #F8F8F8;
        }
        .no-content {
          height: 138px;
          line-height: 138px;
          text-align: center;
          color: #aaa;
          font-size: 16px;
        }
      }
      .template-preview {
        width: 544px;
        height: 220px;
        overflow-x: hidden;
        overflow-y: scroll;
        display: inline-block;
        border: 1px solid #C6CDD7;
        border-radius: 2px;
      }
      .template-preview::-webkit-scrollbar,
      .tpl-list::-webkit-scrollbar,
      .dc-list::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      .template-preview::-webkit-scrollbar-thumb,
      .tpl-list::-webkit-scrollbar-thumb,
      .dc-list::-webkit-scrollbar-thumb {
        opacity: 0.6;
        background: #C1C7CD;
        border-radius: 100px;
      }
    }
    .form-tips-error{
      margin-left: 100px;
      margin-top: 4px;
      margin-bottom: 4px;
      display: block;
      font-size: 12px;
      color: #f92402;
    }
  }
  .confirm-footer {
    padding: 24px;
    text-align: right;
    height: 38px;
    line-height: 38px;
    .confirm-btn{
      display: inline-block;
      width: 80px;
      height: 38px;
      font-size: 14px;
      cursor: pointer;
      line-height: 38px;
      border-radius: 2px;
      text-align: center;
      margin-left: 8px;
    }
  }
}

.dialog-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);
  left: 0;
  top: 0;
  z-index: 1000;
}
</style>
